// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert-module--alert--2JKlN","danger":"Alert-module--danger--9wlYi","success":"Alert-module--success--1vesg"};